export const USER = "USER";

export const LOGOUT = "LOGOUT";
export const LOGOUT_FULFILLED = "LOGOUT_FULFILLED";
export const LOGOUT_PENDING = "LOGOUT_PENDING";
export const LOGOUT_REJECTED = "LOGOUT_REJECTED";

export const LOGIN = "LOGIN";
export const LOGIN_FULFILLED = "LOGIN_FULFILLED";
export const LOGIN_PENDING = "LOGIN_PENDING";
export const LOGIN_REJECTED = "LOGIN_REJECTED";

export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_USERS_FULFILLED = "GET_ALL_USERS_FULFILLED";
export const GET_ALL_USERS_PENDING = "GET_ALL_USERS_PENDING";
export const GET_ALL_USERS_REJECTED = "GET_ALL_USERS_REJECTED";
